import React, {Fragment, useState} from "react";

const InputTodo = () => {

  const [description, setDescription] = useState('');

  const onSubmitForm = async(event) => {
    event.preventDefault();
    try {
      const body = {description};
      const response = await fetch("/api/todos", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body)
      })
      window.location = '/';
    } catch (error) {
      console.error(error.message);
    }
  }

  return (
    <Fragment>
      <h1 className="text-center mt-5">PostgreSQL Todo List</h1>
      <form onSubmit={onSubmitForm} className="d-flex mt-5">
        <input
          type="text"
          className="form-control"
          value={description}
          onChange={e => setDescription(e.target.value)}
        />
        <button className="btn btn-success">Add</button>
      </form>
    </Fragment>
  )
}

export default InputTodo;